import React from "react";

interface ILabel {
  label: string;
  required?: boolean;
}

export default function LLabel({ label, required }: ILabel) {
  return (
    <div className="form-label mb-0 d-flex justify-content-start">
      {`${label} `}
      {required && <span className="text-danger">*</span>}
    </div>
  );
}
